import './index.less';

import { ToastContainer } from '@bfe/moly';
import React, { useLayoutEffect, useState } from 'react';

import SettingGroup from '@/components/SettingGroup';
import { useI18nContext } from '@/i18n/I18n';
import { useStore } from '@/store/useStore';
import { useUserStore } from '@/store/useUser';
import { complianceHide } from '@/utils/complianceHelpers';

import AntiPhishingCode from './comps/AntiPhishingCodeComps';
import EmailAuth from './comps/emailAuth/EmailAuth';
import FundPassword from './comps/FundPassword';
import GoogleAuth from './comps/GoogleAuth';
import ModifyPassword from './comps/modifyPassword/ModifyPassword';
import Passkey from './comps/passkey';
import PhoneAuth from './comps/phoneAuth/PhoneAuth';
import FetchCoinSecurity from './fetchCoinSecurity';
import GuideModifyPassword from './guide/guide-resetpassword';

const componentGroups: {
  title: string;
  key: string;
  components: {
    key: string;
    element: any;
    subMemberHidden?: boolean;
    complianceHiddenConfig?: (config: any) => boolean;
  }[];
}[] = [
  // 双重验证
  {
    title: 'twoFactorAuth',
    key: 'Two-factor-authentication',
    components: [
      {
        key: 'ModifyPassword',
        element: ModifyPassword,
        subMemberHidden: true,
      },
      {
        key: 'EmailAuth',
        element: EmailAuth,
        subMemberHidden: true,
      },
      {
        key: 'PhoneAuth',
        element: PhoneAuth,
        subMemberHidden: true,
      },
      {
        key: 'GoogleAuth',
        element: GoogleAuth,
      },
    ],
  },
  // 高级安全设置
  {
    title: 'accountSenoirSecurity',
    key: 'Advanced Protection',
    components: [
      {
        key: 'Passkey',
        element: Passkey,
        subMemberHidden: true,
        complianceHiddenConfig: (config: any) => {
          return complianceHide(config?.passkey);
        },
      },
      {
        key: 'FundPassword',
        element: FundPassword,
        subMemberHidden: true,
      },
      {
        key: 'AntiPhishingCode',
        element: AntiPhishingCode,
        subMemberHidden: true,
      },
    ],
  },
  // 提币安全
  {
    title: 'fetchCoinSecurityNewTip',
    key: 'fetchCoinSecurityNewTip',
    components: [
      {
        key: 'FetchCoinSecurity',
        element: FetchCoinSecurity,
        subMemberHidden: true,
      },
    ],
  },
];

const Security = ({ loadFn }: { loadFn: () => void }) => {
  const [$t] = useI18nContext();
  const {
    userRole: { isSubmember },
  } = useStore();
  const [visible, setVisible] = useState(
    localStorage.getItem('guide_edit_pwd2') === '1',
  );

  const { complianceConfig } = useUserStore();

  useLayoutEffect(() => {
    loadFn();
  }, []);

  return (
    <>
      {/* 弹窗：系统检测到您的账户存在安全风险。为保证您的账户安全，建议您立即修改登录密码。 */}
      {visible && <GuideModifyPassword onCancel={() => setVisible(false)} />}
      {componentGroups.map(({ title, components, key }) => {
        const visibleComponents = components.filter((component) => {
          let hiddenSubMember = false;
          let hiddenCompliance = false;

          // 如果子账号登录需要隐藏时
          if (component.subMemberHidden) {
            // 判断是否为子账号
            hiddenSubMember = isSubmember;
          }
          if (typeof component.complianceHiddenConfig === 'function') {
            hiddenCompliance =
              component.complianceHiddenConfig(complianceConfig);
          }
          return !hiddenSubMember && !hiddenCompliance;
        });

        if (visibleComponents.length === 0) {
          return null;
        }

        return (
          <SettingGroup
            className="security-setting-group"
            key={key}
            title={title ? $t(title) : ''}
          >
            {visibleComponents.map(({ key, element: Element }) => (
              <Element key={key} />
            ))}
          </SettingGroup>
        );
      })}
      <ToastContainer />
    </>
  );
};
export default Security;
